import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { userRoleNameEnum } from '../const/enum';

@Injectable({
  providedIn: 'root'
})
export class UserGuard {

  constructor(
    private router: Router,
    private utilService: UtilService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let data = this.utilService.loginUserType;
    if (data === userRoleNameEnum.operator || data === userRoleNameEnum.support || data === userRoleNameEnum.supervisor || data === userRoleNameEnum.superAdmin || data === userRoleNameEnum.manager || userRoleNameEnum.operator) {
      return true;
    }
    if (data === userRoleNameEnum.clientSupport) {
      this.router.navigate(['/client-support/dashboard']);
      return false;
    }
    return false;
  }

}
